import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle, FormControl
} from "@mui/material";
import Autocomplete from "@mui/lab/Autocomplete";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetOperationLogsList,
	getOperationLogsListDetails
} from "../../redux/actions/getOperationLogsListAction";

import {
	getWalletTransactionList,
	resetGetWalletTransactionList
} from "../../redux/actions/getWalletTransactionListAction";
import {
	resetGenerateWalletTransactionReportFile,
	generateWalletTransactionReportFileReq
} from "../../redux/actions/generateWalletTransactionReportFileAction";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
// import {
// 	MuiPickersUtilsProvider,
// 	DatePicker
// } from "@mui/material/pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import getSymbolFromCurrency from "currency-symbol-map";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const OperationLogs = () => {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [customerId, setCustomerId] = useState("");
	const [currency, setCurrency] = useState("");
	const [transactionId, setTransactionId] = useState("");
	const [operationType, setOperationType] = useState("");
	const [isFee, setIsFee] = useState("");
	const [getOperationLogListArray, setGetOperationLogListArray] = useState([]);
	const [getOperationLogsListStatus, setGetOperationLogsListStatus] =
		useState(false);
	const [walletName, setWalletName] = useState("");
	const [operationId, setOperationId] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(5);
		const [getTransactionReportFileResStatus, setGetTransactionReportFileRes] =
			useState(false);
	const [page, setPage] = useState(0);
	const [pageNo, setPageNo] = useState(0);
	const classes = useStyles();

	const Theme = useSelector((state) => state.theme.theme);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);
	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "walletName") {
			// setWalletName(value);
			Util.verifyAlphabet(value)
				? setWalletName(value)
				: setWalletName(walletName);
		}

		if (name === "operationId") {
			// setOperationId(value);
			Util.verifyNumber(value)
				? setOperationId(value)
				: setOperationId(operationId);
		}

		// if (name === "customerId") {
		// 	// setCustomerId(value);
		// 	Util.verifyNumber(value)
		// 		? setCustomerId(value)
		// 		: setCustomerId(customerId);
		// }
		if (name === "customerId") {
			// console.log("CustIDDDD", customerId)
			setCustomerId(value)
		}

		if (name === "transactionId") {
			setTransactionId(value);
		}

		if (name === "operationType") {
			// setOperationType(value);
			setOperationType(value == "Select OperationType" ? "" : value);
		}

		if (name === "isFee") {
			// setIsFee(value);
			setIsFee(value == "All" ? "" : value);
		}
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
		if (date > selectedToDate) {
			setSelectedToDate(date)
		}
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	useEffect(() => {
		getTransactionTypeList();
	}, []);

	const getOperationListRes = useSelector(
		({ getOperationList }) => getOperationList
	);

	const getOperationLogsListRes = useSelector(
		({ getOperationLogsList }) => getOperationLogsList
	);

	const getTransactionTypeList = () => {
		if (getTransactionTypeListRes.data.status == "success") {
			setGetTransactionTypeListResArray(
				getTransactionTypeListRes.data.transactionType
			);
		}
	};

	//console.log(getOperationLogsListRes);
	//console.log("getOperationLogsListRes");

	const OperationLogsReq = () => {
		if (!selectedDate || !selectedToDate) {
			alert("Please enter a Date..!!");
			return; // Stop the execution if "From Date" is not selected
		}
		setIsLoading(true);
		setGetOperationLogsListStatus(true);
		const getOperationLogsListDetailsReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			walletTransactionMasterDetailsRequestVO: {
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: operationId,
				isFee: isFee,
				walletCustomerId: customerId.split("-")[0] || "",
				transactionType: operationType,
				walletname: walletName
			}
		};
		return dispatch(getOperationLogsListDetails(getOperationLogsListDetailsReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			OperationLogsReq();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getOperationLogsListStatus) {
			if (getOperationLogsListRes.data.status == "success") {
				setIsLoading(false);
				setGetOperationLogListArray(
					[].concat(getOperationLogsListRes.data.transactionList)
				);
			}
			if (getOperationLogsListRes.data.status == "failed") {
				setIsLoading(false);
				setGetOperationLogListArray(getOperationLogsListRes.data);
				if (
					getOperationLogsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getOperationLogsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getOperationLogsListRes.data.status == "Failed") {
				setIsLoading(false);
				setGetOperationLogListArray(getOperationLogsListRes.data);
				if (
					getOperationLogsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getOperationLogsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getOperationLogsListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setGetOperationLogListArray(getOperationLogsListRes.data);
			}
		}
	}, [getOperationLogsListRes.data.status]);

	useEffect(() => {
		if (getOperationLogsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getOperationLogsListRes.data.status]);

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}
	
	// IF ANY ONE ENTITY FOUND THEN PAGE NUMBER 1 GOING TO getWalletTransactionListReq THIS REQUEST  
	function pageNumberOne() {

		if (transactionId ) {
			return 1
		} else {
			return 0
		}

	}

	const csv = "1";
	const pdf = "0";

	const getTransactionReportFileExcelOrPdf = (csvOrPdf) => {
		setGetTransactionReportFileRes(true);
		const getTransactionReportListObj = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			walletTransactionMasterDetailsRequestVO: {
				currency: currency,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: transactionId,
				isFee: isFee,
				walletCustomerId: customerId.split("-")[0],
				reportFileType: csvOrPdf == "1" ? "csv" : "pdf",
				pageNo: pageNumberOne() ? 1 : pageNo + 1,
				records: rowsPerPage
			}
		};

		return dispatch(
			generateWalletTransactionReportFileReq(
				getTransactionReportListObj,
				authToken
			)
		);
	};

	return (
		<>
			<>
				<Layout>
					<Card>
						{/* <BackButton /> */}
						<Grid
							container
							spacing={2}
							style={{ padding: "25px", marginTop: "2rem" }}
						>
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="From Date"
											format="dd/MM/yyyy"
											value={selectedDate}
											onChange={handleDateChange}
											disableFuture={true}
										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="To Date"
											format="dd/MM/yyyy"
											value={selectedToDate}
											onChange={handleToDateChange}
											disableFuture={true}
											minDate={selectedDate}
										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							{/* <Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Customer Id"
									type="text"
									fullWidth
									value={customerId || ""}
									name="customerId"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
								/>
							</Grid> */}

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={customerId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setCustomerId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Customer ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}
											sx={{
												"& .MuiInput-underline:before": {
													borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
													borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
													borderBottomColor: "gray", // White color after focus
												},
											}}

											name="customerId"

											variant="standard"
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Wallet Name"
									type="tel"
									fullWidth
									value={walletName}
									name="walletName"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
								/>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Fee Id"
									type="tel"
									fullWidth
									value={operationId}
									name="operationId"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Transaction Type"
									type="name"
									fullWidth
									name="operationType"

									// value={operationType || ""}
									defaultValue={"Select Transaction Type" || operationType}
									onChange={handleChange}
								>
									<MenuItem
										sx={{ paddingTop: "5px" }}
										value="Select Transaction Type"
										selected="Select TransactionType"
									>
										Select Transaction Type
									</MenuItem>

									{(() => {
										if (getOperationListRes.success) {
											return []
												.concat(getOperationListRes.data.operationBlockType)
												.map((c) => (
													<MenuItem value={c} key={c}>
														{c}
													</MenuItem>
												));
										} else {
											return <MenuItem>No Data</MenuItem>;
										}
									})()}
								</TextField>
							</Grid>
							{/* 
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="IsFee"
									type="name"
									fullWidth
									name="isFee"
									// value={isFee || ""}
									defaultValue={"All" || isFee}
									onChange={handleChange}
								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
							</Grid> */}

							<Grid item xs={12} sm={12} md={3} lg={3}>
								{/* <Button
                  style={{
                    marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                    marginTop: "1rem",
                  }}
                  endIcon={<AiOutlineSearch />}
                  variant="contained"
                  onClick={OperationLogsReq}
                >
                  Search
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={OperationLogsReq}
								>
									Search <SearchIcon />
								</CustomButton>
							</Grid>
						</Grid>

						{/* <Grid
              container
              style={{
                padding: "10px",
                marginTop: "1.5rem",
                marginBottom: "15px",
              }}
            >
              <Grid item md={5}>
                <Button
                  style={{
                    marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  endIcon={<AiOutlineSearch />}
                  variant="contained"
                  onClick={OperationLogsReq}
                >
                  Search
                </Button>
              </Grid>
              <Grid item md={7}></Grid>
            </Grid> */}
					</Card>

					{isLoading ? (
						<LoadingSpinner />
					) : getOperationLogListArray.length == undefined ||
						!getOperationLogsListStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Fee Transaction List
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert
										className="my-3 tableHeaderColor"
										variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
									>
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Fee Transaction List
									</Typography>
								</Grid>
								<Grid
									container
									style={{
										padding: "10px",
										textAlign: "center",
										justifyContent: "right"
									}}
								>
									<Grid item xs={4} sm={4} md={1} lg={1}>
										<img
											src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}
											alt="m-transact"

											style={{ height: "30px", cursor: "pointer" }}
											onClick={() => {
												getTransactionReportFileExcelOrPdf(csv);
											}}
										/>
									</Grid>
									<Grid item xs={4} sm={4} md={1} lg={1}>
										<img
											src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}
											alt="m-transact"

											style={{ height: "30px", cursor: "pointer" }}
											onClick={() => {
												getTransactionReportFileExcelOrPdf(pdf);
											}}
										/>
									</Grid>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Date{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Fee ID{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Customer ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Amount
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Currency
												</TableCell>
												{/* <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          From Customer
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          To Customer
                        </TableCell> */}

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													From Account
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													To Account
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction Type
												</TableCell>

												{/* <TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Is Fee
												</TableCell> */}



												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													From Customer
												</TableCell>


												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													To Customer
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction Id
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getOperationLogListArray &&
												[]
													.concat(getOperationLogListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.registeredTime}
															</TableCell>
															<TableCell align="center">
																{row.transactionId}
															</TableCell>
															<TableCell align="center">
																{row.fromCustomerId}
															</TableCell>
															<TableCell align="center">
																{row.transactionAmount}
															</TableCell>

															<TableCell align="center">
																{row.currency}
																{/* {row.transactionAmount} */}
															</TableCell>
															{/* <TableCell align="center">
                                {" "}
                                {row.fromCustomerName}
                              </TableCell>
                              <TableCell align="center">
                                {row.toCustomerName}
                              </TableCell> */}

															<TableCell align="center">
																{row.fromWalletName ? row.fromWalletName : '-'}
															</TableCell>
															<TableCell align="center">
																{row.toWalletName ? row.toWalletName : '-'}
															</TableCell>
															<TableCell align="center">
																{row.transactionType}
															</TableCell>
															{/* <TableCell align="center">{row.isFee}</TableCell> */}
															<TableCell align="center">
																{row.fromCustomerName}
															</TableCell>
															<TableCell align="center">
																{row.toCustomerName}
															</TableCell>
															<TableCell align="center">
																{row.parentId}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getOperationLogListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)}
				</Layout>
			</>
		</>
	);
};

export default OperationLogs;
